import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import AppLoader from '@projectK/components/AppLoader';

const ProductWaiverMain = (props) => {
  const { isMobile, mobileMode } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import('../MobileComponents/ProductWaiverMob');
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/ProductWaiverWeb');
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? (
    <LoadedComponent {...props} mode={mobileMode} />
  ) : (
    <AppLoader />
  );
};

export default ProductWaiverMain;
